import * as React from 'react';
import { useEffect, useState } from 'react';
import { PackModel } from '../../../../core/models/PackModel';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react';
import { ButtonWidget } from '../../../../widgets/controls/ButtonWidget';
import { GroupUserStatus } from '@foxbun/lib-goferal-types';
import { useNavigate } from 'react-router-dom';
import { useSystem } from '../../../../hooks/useSystem';
import { ResourcePageHeaderWidget } from '../../../../widgets/pages/ResourcePageHeaderWidget';

export interface PackHeaderWidgetProps {
  pack: PackModel;
}

export const PackJoinButtonWidget: React.FC<PackHeaderWidgetProps> = observer((props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const system = useSystem();

  useEffect(() => {
    props.pack.loadMyRelation();
  }, []);

  const { pack } = props;
  if (pack.my_status_loading) {
    return null;
  }
  if (!pack.my_status) {
    return (
      <ButtonWidget
        loading={loading}
        label="Join"
        action={() => {
          setLoading(true);
          pack.requestToJoin().finally(() => {
            setLoading(false);
          });
        }}
      />
    );
  }
  if (pack.my_status.status === GroupUserStatus.INVITED) {
    return (
      <ButtonWidget
        loading={loading}
        label="Revoke invitation"
        action={() => {
          setLoading(true);
          pack.revokeRequestToJoin().finally(() => {
            setLoading(false);
          });
        }}
      />
    );
  }
  return (
    <ButtonWidget
      loading={loading}
      label="Leave"
      action={async () => {
        let confirm = await system.dialog_store.showConfirmDialog({
          title: 'Leave pack?',
          desc: 'Are you sure you wish to leave?'
        });
        if (!confirm) {
          return;
        }

        setLoading(true);
        pack.leave().finally(() => {
          setLoading(false);
          navigate(system.user.link, { state: 'push' });
        });
      }}
    />
  );
});

export const PackHeaderWidget: React.FC<PackHeaderWidgetProps> = observer((props) => {
  const { pack } = props;
  return (
    <ResourcePageHeaderWidget
      hero_image={pack.headerImage}
      label={pack.data?.name}
      primary_image={pack.image}
      primaryAction={<PackJoinButtonWidget pack={pack} />}
      meta={[
        {
          key: 'visibility',
          primary: true,
          icon: faEye,
          value: pack.data?.public ? 'Public' : 'Private'
        }
      ]}
    />
  );
});
